<template>
    <div class="NoticeCard" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading">
      <!-- 弃用 -->
      <!-- <div v-if="!shownull">
        <div class="notice-item" v-for="(item, index) in noticeData" :key="index" @click="toDetail(item)">
          <div class="per-line">
              <div class="flex flex-j-c-sb">
                  <p class="title-left ellipsis">{{item.title}}</p>
                  <p class="title-right">{{item.addtime}}</p>
              </div>
          </div>
          <div class="NoticeCard-content ellipsis-more" v-html="item.content"></div>
        </div>
      </div> -->
      <div v-if="!shownull">
        <div class="New-card flex flex-j-c-sb" v-for="(item, index) in noticeData" :key="index" @click="toDetail(item)">
          <div class="Newitem-msg flex flex-j-c-sb">
            <p class="msg-title ellipsis-more" style="-webkit-line-clamp: 3;">{{item.title}}</p>
            <p class="msg-time">{{item.addtime}}</p>
          </div>
          <img class="Newitem-img" :src="item.cover_pic" alt=""/>
          <!-- <img class="Newitem-img" v-lazy="item.cover_pic" /> -->
        </div>
      </div>
      <DataNull v-if="shownull"/>
      <Nomore v-if="showNoMore"/>
    </div>
</template>

<script>
import {NoticeList} from '@/api';
import { MessageBox } from 'mint-ui';
import DataNull from '@/components/DataNull';
import Nomore from '@/components/Nomore';

export default {
  name: 'NoticeCard',
  components: {
    DataNull,
    Nomore
  },
  data(){
    return{
      noticeData: [],
      page: 1,
      loading: true,
      shownull: false,
      pagetype: 4,
      showNoMore: false
    }
  },
  created() {
    this.pagetype = this.$route.query.type;
    this.getList(1);
  },
  methods: {
    toDetail(e) {
      let uid = JSON.parse(localStorage.getItem('cww_data')).id;
      window.location.href = `${window.location.origin}/NoticeDetail?id=${e.id}&invitorId=${uid}`
    },
    loadMore(){
      if (this.loading) return false;
      this.loading = true
      this.page += 1;
      this.getList(2);
    },
    getList(e) {
      NoticeList({type: this.pagetype, page: this.page, limit: 20}).then(res => {
        if (res.code !== 0) { this.shownull = true; };
        res.data.list.map(item => {
          item.content = item.content.replace(/\<img/gi, '<img style="max-width:100%;width:100%;margin-top:10px;margin-bottom:10px;height:auto"')
        })
        if (e === 1) {
          this.noticeData = res.data.list;
        } else {
          this.noticeData = this.noticeData.concat(res.data.list);
        }
        if (res.data.list.length === 0) { this.shownull = true; };
        if (res.data.list.length === 20) { this.loading = false; };
        if (res.data.list.length !== 20 && res.data.list.length !== 0) { this.showNoMore = true };
        if (Number(res.data.totalCount) === this.noticeData.length) { this.loading = true;this.showNoMore = true };
      })
    }
  },
  watch: {
    $route(){
      this.page = 1;
      this.pagetype = this.$route.query.type;
      this.loading = true,
      this.shownull = false,
      this.showNoMore = false
      this.getList(1);
    },
  }
};
</script>

<style scoped lang="less">
// image[lazy=loading] {
//   width: 100%;
//   height: 100%;
//   margin: auto;
// }
.NoticeCard{
  // margin-bottom: 0.3rem; 
    .notice-item{
        background: white;
        padding: 0 0.2rem;
        margin: 0.1rem 0 0;
    }
    
    &>:last-child{
        border: none;
    }
    .title-left{
        font-size: 0.15rem;
        font-weight: bold;
        color: #333333;
        text-align: left;
        max-width: 80%;
    }
    .title-right{
        color: #999999;
        font-size: 0.12rem;
    }
    .NoticeCard-content{
        padding: 0.15rem 0;
        text-align: left;
        line-height: 0.2rem;
    }
    .New-card{
    background: white;
    width: 100%;
    border-bottom: 0.5px solid #EEEEEE;
    padding: 0.16rem;
    margin-top: 0.1rem;
    .Newitem-msg{
      max-width: 70%;
      text-align: left;
      flex-direction: column;
      font-size: 0.15rem;
      color: #000000;
      .msg-time{
        color: #666666;
        font-size: 0.12rem;
      }
    }
    .Newitem-img{
      width: 0.8rem;
      height: 0.8rem;
    }
  }
}
</style>
